<template>
  <div class="table">
    <div class="container">
      <div class="handle-box">
        <el-form :model="queryCondition" ref="queryCondition" :label-position="labelPosition" label-width="120px" class="searchForm">
          <el-row>
            <el-col :span="24">
              <el-row :gutter="20">
                <el-col :span="6">
                  <el-form-item label="计划月" prop="monthList">
                    <el-select v-model="queryCondition.monthList" clearable multiple placeholder="请选择(支持多选)" style="width:100%" class="multiple_sel">
                      <el-option :key="index" v-for="(item,index) in monthOptions" :label="item" :value="item"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="Category2" prop="category2CodesList">
                    <el-select v-model="queryCondition.category2CodesList" clearable multiple filterable placeholder="请选择(支持多选)" style="width:100%" class="multiple_sel">
                      <el-option :key="index" v-for="(item,index) in categoryList2" :label="item.name" :value="item.code"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="供应商集团名称" prop="groupName">
                    <el-input v-model="queryCondition.groupName" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="计划状态" prop="planStatus">
                    <ic-select clearable table="TT_QSPI_QBR" field="PLAN_STATUS" v-model="queryCondition.planStatus" style="width:100%"></ic-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-collapse-transition>
              <el-col :span="24" v-if="isShow">
                <el-row :gutter="20">
                  <el-col :span="6">
                    <el-form-item label="QBR状态" prop="qbrStatus">
                      <ic-select clearable table="TT_QSPI_QBR" :excludes="excludesValue" field="QBR_STATUS" title="queryQBR" v-model="queryCondition.qbrStatus" style="width:100%"></ic-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="QBR Result" prop="result">
                      <ic-select clearable table="TT_QSPI_QBR" field="RESULT" v-model="queryCondition.result" style="width:100%"></ic-select>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
            </el-collapse-transition>
          </el-row>
          <el-row type="flex" justify="center" align="middle">
            <el-button size="mini" @click="onSearch" type="primary">查询</el-button>
            <el-button size="mini" @click="onReset" type="primary">重置</el-button>
            <span class="arrowDown" @click="isShow=!isShow">{{isShow?'收缩':'展开'}}<i :class="isShow?'el-icon-arrow-up iconBtn':'el-icon-arrow-down iconBtn'"></i></span>
          </el-row>
        </el-form>
      </div>
      <el-row class="action-btn-row">
        <el-button size="mini" class="btn" type="primary" @click="onExport" v-acl="QSPI_QBR_EXPORT_HIST_PERF">供应商历史表现报表</el-button>
      </el-row>
      <ux-grid ref="plxTable" :data="tableData" @selection-change="selectionChange" max-height="650" show-overflow="tooltip" highlight-current-row>
        <ux-table-column align="center" type="checkbox" width="80" />
        <ux-table-column align="center" title="Category2" min-width="140" field="category2Name">
          <template v-slot="scope">
            <el-button type="text" @click="onDetail(scope.row)">{{scope.row.category2Name}}</el-button>
          </template>
        </ux-table-column>
        <ux-table-column align="center" title="供应商集团名称" resizable min-width="120" field="groupName"></ux-table-column>
        <ux-table-column align="center" title="计划月" resizable min-width="140" field="month"></ux-table-column>
        <ux-table-column align="center" title="QBR日期" resizable min-width="100" field="qbrDate"></ux-table-column>
        <ux-table-column align="center" title="计划状态" resizable min-width="100" field="planStatusI18n"></ux-table-column>
        <ux-table-column align="center" title="QBR Result" resizable min-width="100" field="result"></ux-table-column>
        <ux-table-column align="center" title="QBR状态" resizable min-width="100" field="qbrStatusI18n"></ux-table-column>
        <ux-table-column align="center" title="更新人" resizable min-width="100" field="updateName"></ux-table-column>
        <ux-table-column align="center" title="更新时间" resizable min-width="100" field="updateDate"></ux-table-column>
      </ux-grid>
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount" :page-count="pages">
        </el-pagination>
      </div>
    </div>
    <el-dialog :visible.sync="showDetailDialog" append-to-body width="80%" :close-on-click-modal="false" @close="closeDialog">
      <detailDialog v-if="showDetailDialog"></detailDialog>
    </el-dialog>
  </div>
</template>
<script>
import store from '@/store/index'
import paginationMixin from '@/mixins/pagitionMixin';
import commonFunction from "@/utils/dataTableUtils";
import IcSelect from "@/components/common/icSelect";
import QBRApi from "@/api/QBR/index";
import detailDialog from './MaintainceQbrPlan.vue'
import { fileService } from "@/api/common/file-utils";
import DQMPApi from "@/api/DQMP/index";
export default {
  name: 'QBR',
  mixins: [paginationMixin],
  components: {
    IcSelect,
    detailDialog
  },
  data() {
    return {
      categoryList2: [],
      planStatusList: [],
      qbrStatusList: [],
      multipleSelection: [],
      tableData: [],
      groupCodeList: [],
      monthOptions: [],
      queryCondition: {
        category2CodesList: [],
        monthList: [],
        groupName: "",
        planStatus: '',
        qbrStatus: "",
        result: "",
        pageNum: 1,
        pageSize: 15,
      },
      isShow: false,
      showDetailDialog: false,
      formData: null,
      totalCount: 0,
      pages: 1,
    }
  },
  watch: {
    queryCondition() {
      let _this = this;
      store.dispatch('uploadListParams', { routeName: _this.$route.name, reqData: _this.queryCondition })
    }
  },
  beforeRouteEnter(to, from, next) {
    console.log('from', from);
    console.log('from', to);
    if (from.path !== '/qspiQBR/detail' && from.path !== '/qspiOtherQBR') {
      var newDate = new Date()
      var y = newDate.getFullYear()
      console.log('y', y);
      var m = newDate.getMonth() + 1
      m = m < 10 ? '0' + m : m
      console.log('m', m);
      to.meta.reqData.monthList = []
      to.meta.reqData.monthList.push(y + '-' + m)
    }
    if (from.path === '/qspiOtherQBR') {
      to.meta.reqData.ttQspiFacilityFactorScoreId = to.query.ttQspiFacilityFactorScoreId
    }
    QBRApi.getQbrMaintainceLists(to.meta.reqData).then((res) => {
      next(vm => {
        vm.queryCondition = to.meta.reqData;
        vm.tableData = res.data.records;
        vm.totalCount = res.data.total;
      })
    })
  },
  created() {
    this.getCategory2Lists()
    this.getMonth()
    //用户所属系统(SUP供应商)
    this.emplFlag = localStorage.getItem("ms_emplFlag");
    //非供应商用户不显示草稿状态
    if (this.emplFlag == 'SUP') {
      this.excludesValue = "DRAFT";
    }
    var newDate = new Date()
    var y = newDate.getFullYear()
    console.log('y', y);
    var m = newDate.getMonth() + 1
    m = m < 10 ? '0' + m : m
    console.log('m', m);
    this.queryCondition.monthList.push(y + '-' + m)
  },
  methods: {
    queryData() {
      QBRApi.getQbrMaintainceLists(this.queryCondition).then(res => {
        this.tableData = res.data.records;
        this.totalCount = res.data.total;
        this.pages = res.data.pages;
        this.$refs.plxTable.reloadData(res.data.records)
      });
    },
    getMonth() {
      QBRApi.getMonth().then(res => {
        this.monthOptions = res
      })
    },
    onSearch() {
      this.queryCondition.pageNum = 1
      this.queryCondition.pageSize = 15
      this.queryData()
    },
    getCategory2Lists() {
      var param = {
        categoryLevel: 2,
      }
      QBRApi.getCategoryLists(param).then(res => {
        this.categoryList2 = res.data
      });
    },
    onDetail(row) {
      var year = row.month.split('-')[0]
      this.$router.push({
        path: '/qspiQBR/detail',
        query: {
          ttQspiQbrDetailId: row.ttQspiQbrDetailId,
          from: "qbr",
          year: year,
        }
      })
    },
    // 选中的行
    selectionChange(row) {
      console.log('row', row);
      this.groupCodeList = []
      this.multipleSelection = row
      row.forEach(ele => {
        this.groupCodeList.push(ele.groupCode)
      });
    },
    onExport() {
      if (this.groupCodeList.length == 0) {
        this.$my_message('请先选择数据后再操作', 'error');
        return false
      }
      var groupCodeList = this.groupCodeList.reduce((cur, next) => {
        !cur.includes(next) && cur.push(next);
        return cur;
      }, []);
      console.log('groupCodeList', groupCodeList);
      QBRApi.performanceDownload({
        groupCodeList: groupCodeList
      }).then(res => {
        fileService.respToFile(res, '供应商历史表现报表.xlsx');
        this.groupCodeList = []
        this.$refs['plxTable'].clearSelection()
      });
    },
    handleSizeChange(val) {
      this.queryCondition.pageSize = val
      this.queryData()
    },
    handleCurrentChange(val) {
      this.queryCondition.pageNum = val
      this.queryData()
    },
    onReset() {
      this.$refs['queryCondition'].resetFields()
      this.queryCondition = {
        category2CodesList: [],
        monthList: [],
        groupName: "",
        planStatus: '',
        qbrStatus: "",
        result: "",
        pageNum: 1,
        pageSize: 15,
      }
      this.queryData();
    },
  },
  extends: commonFunction
}
</script>
<style scoped >
</style>
